interface PageMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
}

export const pageMainTitle: PageMainTitle = {
  category: 'メールマガジン',
  title: 'Mail magazine',
  sub_title: '',
  sub_title2: '',
  text: 'UX/UIデザイン・システム内製化・DX推進についてのお役立ちメソッドや、限定イベントや最新事例などをお届けします。',
}
